import type { ComponentDefinition, Terminal } from "../types";

function terminals(ratingA: number): Terminal[] {
  return [
    { id: "ac-in-l", label: "LINE L", polarity: "neutral", direction: "input", maxAmp: ratingA, side: "left", offset: 0.3 },
    { id: "ac-in-n", label: "LINE N", polarity: "neutral", direction: "input", maxAmp: ratingA, side: "left", offset: 0.7 },
    { id: "ac-out-l", label: "LOAD L", polarity: "neutral", direction: "output", maxAmp: ratingA, side: "right", offset: 0.3 },
    { id: "ac-out-n", label: "LOAD N", polarity: "neutral", direction: "output", maxAmp: ratingA, side: "right", offset: 0.7 },
  ];
}

// Contacts only: both poles open together. The engine does not simulate
// overload/leakage trips, and protective earth never passes through a breaker.
function states(): ComponentDefinition["simulateStates"] {
  return {
    default: "on",
    options: [
      { id: "on", label: "On", intraLinks: [["ac-in-l", "ac-out-l"], ["ac-in-n", "ac-out-n"]] },
      { id: "off", label: "Off", intraLinks: [] },
      { id: "tripped", label: "Tripped", intraLinks: [] },
    ],
  };
}

export const AC_BREAKERS: ComponentDefinition[] = [
  {
    // Blue Sea 7294 product specifications: two poles, 16 A, 120/240 V AC.
    // https://www.bluesea.com/products/7294/A-Series_White_Toggle_Circuit_Breaker_-_Double_Pole_16A
    id: "breaker-ac-blue-sea-7294",
    name: "Blue Sea 7294 AC Circuit Breaker 16A",
    shortName: "AC breaker 16A · 7294",
    subtitle: "Double-pole AC circuit breaker",
    category: "distribution",
    manufacturer: "Blue Sea Systems",
    model: "7294",
    width: 200,
    height: 110,
    terminals: terminals(16),
    simulateStates: states(),
  },
  {
    // Blue Sea 7560: two poles, 30 A AC, 120/240 V AC, 5000 A interrupt rating.
    // https://www.bluesea.com/products/7560/C-Series_Flat_Rocker_Circuit_Breaker_-_Double_Pole_30A_AC
    id: "breaker-ac-blue-sea-7560",
    name: "Blue Sea 7560 AC Main Circuit Breaker 30A",
    shortName: "AC main 30A · 7560",
    subtitle: "Double-pole AC circuit breaker",
    category: "distribution",
    manufacturer: "Blue Sea Systems",
    model: "7560",
    width: 200,
    height: 110,
    terminals: terminals(30),
    simulateStates: states(),
  },
  {
    // Blue Sea 3091 and IST-0010: 230 V, 16 A, two poles, 30 mA leakage trip.
    // https://www.bluesea.com/products/3091/C-Series_ELCI_Main_Circuit_Breaker_-_Double_Pole_230V_AC_16A
    id: "breaker-ac-blue-sea-3091",
    name: "Blue Sea 3091 AC ELCI Circuit Breaker 16A 230V",
    shortName: "ELCI 16A 230V · 3091",
    subtitle: "Double-pole ELCI / RCBO, 30 mA",
    category: "distribution",
    manufacturer: "Blue Sea Systems",
    model: "3091",
    acVoltage: 230,
    width: 210,
    height: 110,
    terminals: terminals(16),
    simulateStates: states(),
  },
];
